<template>
    <auth-show/>
</template>

<script>
import AuthShow from '@/components/auth/show/AuthShow'
export default {
  name: 'view-auth-show',
  components: { AuthShow }
}
</script>
